// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/opt/build/repo/src/pages/404.js"),
  "component---src-pages-dashboard-js": require("gatsby-module-loader?name=component---src-pages-dashboard-js!/opt/build/repo/src/pages/dashboard.js"),
  "component---src-pages-benchmarks-js": require("gatsby-module-loader?name=component---src-pages-benchmarks-js!/opt/build/repo/src/pages/benchmarks.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js"),
  "component---src-pages-page-2-js": require("gatsby-module-loader?name=component---src-pages-page-2-js!/opt/build/repo/src/pages/page-2.js"),
  "component---src-pages-pricing-js": require("gatsby-module-loader?name=component---src-pages-pricing-js!/opt/build/repo/src/pages/pricing.js"),
  "component---src-pages-signup-js": require("gatsby-module-loader?name=component---src-pages-signup-js!/opt/build/repo/src/pages/signup.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "dashboard.json": require("gatsby-module-loader?name=path---dashboard!/opt/build/repo/.cache/json/dashboard.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "benchmarks.json": require("gatsby-module-loader?name=path---benchmarks!/opt/build/repo/.cache/json/benchmarks.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "page-2.json": require("gatsby-module-loader?name=path---page-2!/opt/build/repo/.cache/json/page-2.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "pricing.json": require("gatsby-module-loader?name=path---pricing!/opt/build/repo/.cache/json/pricing.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "signup.json": require("gatsby-module-loader?name=path---signup!/opt/build/repo/.cache/json/signup.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json")
}

exports.layouts = {
  "component---src-layouts-index-js": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js